import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from '@emotion/styled';
import PopFidget from './games/PopFidget';
import BreathingExercise from './pages/BreathingExercise';
import StressReliefTips from './pages/StressReliefTips';
import StressReliefHerbs from './pages/StressReliefHerbs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`;

const App: React.FC = () => {
  return (
    <Router>
      <AppContainer>
        <Routes>
          <Route path="/" element={<PopFidget />} />
          <Route path="/breathing" element={<BreathingExercise />} />
          <Route path="/tips" element={<StressReliefTips />} />
          <Route path="/herbs" element={<StressReliefHerbs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
        <Footer />
        <CookieConsent />
      </AppContainer>
    </Router>
  );
};

export default App; 